export const EntityCommentRoutes = {
    AddComment: "EntityComment/AddComment",
    UpdateComment: "EntityComment/UpdateComment",
    DeleteComment: "EntityComment/DeleteComment",
    GetComments: "EntityComment/GetComments",
    GetPrivateNoteCountsForEntity: "EntityComment/GetPrivateNoteCountsForEntity"
}

